import { useState } from "preact/hooks"
import { Button } from "./buttons"
import { Link } from "./link"
import { Text } from "./text"
import { TextInput } from "./text-input"

export const ContactForm = ({
  heading,
  address,
  address_email,
  phone,
  email,
  button,
  warning,
  redirect,
  onSubmit,
}) => {
  // Try to get onSubmit from FormContext first, then MenuContext, then from props
  // if (!onSubmit) {
  //   try {
  //     const formContext = useFormContext()
  //     onSubmit = formContext.onSubmit
  //   } catch {
  //     try {
  //       const menuContext = useMenuContext()
  //       onSubmit = menuContext.onSubmit
  //     } catch {
  //       // No context available, will use prop
  //     }
  //   }
  // }

  const [phoneVal, setPhoneVal] = useState("")
  const [emailVal, setEmailVal] = useState("")

  const submitIntercept = () => {
    const valueStore = [
      { name: "phone", value: phoneVal },
      { name: "email", value: emailVal },
    ]
    onSubmit(valueStore, true, redirect)
  }

  return (
    <details class="contactform">
      <summary>{heading}</summary>
      <form>
        <Text text={heading} class="lead" />
        <Link url={`mailto:${address_email}`} linktext={address_email} />
        <Text text={address} />
        <TextInput name="phone" label={phone} onChange={setPhoneVal} />
        <TextInput name="email" label={email} onChange={setEmailVal} />
        <Button
          label={button}
          type="submit"
          onClick={submitIntercept}
          disabled={phoneVal === "" && emailVal === ""}
        />
      </form>
      <div class="warning">
        <Text text={warning.heading} class="lead" />
        <Text text={warning.text} />
      </div>
    </details>
  )
}
